import { message, Modal, Tabs } from "antd";
import { Tab } from "rc-tabs/lib/interface"
import { ProductGroup } from "../../../api/product/productTypes";
import SkuManagementTab from "./SkuManagementTab";
import ProductInformationTab from "./ProductInformationTab";
import { usePostProductGroupMutation, usePutProductGroupMutation } from "../../../api/product/productsApi";

export default function EditProductModal(props: {
  title: string;
  pg?: ProductGroup;
  setPg: (pg: ProductGroup) => void;
  onClose: () => void;
}) {
  const [postPg] = usePostProductGroupMutation();
  const [putPg] = usePutProductGroupMutation();
  const [messageApi, ctxHolder] = message.useMessage();

  const tabs: Tab[] = [
    {
      key: "1",
      label: "Product Information",
      children: props.pg &&
        <ProductInformationTab p={props.pg} setP={props.setPg} />
    },
    {
      key: "2",
      label: "SKU Management",
      children: props.pg &&
        <SkuManagementTab p={props.pg} setP={props.setPg} />
    }
  ]

  function handleSave() {
    if (!props.pg) {
      return;
    }
    console.log("saving/updating pg", props.pg);
    if (props.pg.Id === "") {
      postPg(props.pg)
      .unwrap()
      .then(() => {
        messageApi.success("Saved product data");
        props.onClose();
      })
      .catch(() => messageApi.error(
        "Error saving product data. If this issue persists, please contact "
        + "the dev team"))
    } else {
      putPg(props.pg)
      .unwrap()
      .then(() => {
        messageApi.success("Saved product data");
        props.onClose();
      })
      .catch(() => messageApi.error(
        "Error saving product data. If this issue persists, please contact "
        + "the dev team"))
    }
  }

  return (<>
    {ctxHolder}
    <Modal
      title={props.title}
      open={!!props.pg}
      onOk={handleSave}
      onCancel={props.onClose}
      width={800}
    >
      {props.pg &&
        <Tabs
          type="card"
          defaultActiveKey="1"
          items={tabs}
        />
      }
    </Modal>
  </>)
}